<template>
  <div v-if="list.length" class="top_post_list">
    <div
      v-for="item in visibleList"
      :key="String(getPostId(item))"
      class="top_post_list__item"
      @click="goPost(item)"
    >
      <div class="top_post_list__title">
        <span class="top_post_list__tag" :style="item.topColor ? { backgroundColor: item.topColor } : undefined">置顶</span>
        <div class="top_post_list__text">{{ item.title }}</div>
      </div>
    </div>
    <div v-if="list.length > defaultCount" class="top_post_list__toggle" @click="toggleExpanded">
      {{ expanded ? '收起 ≪' : '展开更多置顶 ≫' }}
    </div>
  </div>
</template>

<script>
import { saveForumPostSnapshot } from '@/utils/forum/postSnapshotCache';

export default {
  name: 'ForumTopPostList',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    defaultCount: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    visibleList() {
      return this.expanded ? this.list : this.list.slice(0, this.defaultCount);
    },
  },
  methods: {
    getPostId(item) {
      return item.postsId || item.postId || '';
    },
    goPost(item) {
      const postId = this.getPostId(item);
      if (!postId) return;
      this.$emit('post-click', item);
      saveForumPostSnapshot(item, postId);
      this.$router.push({ name: 'forum-post-detail', params: { postId } });
    },
    toggleExpanded() {
      this.expanded = !this.expanded;
      this.$emit('toggle', this.expanded);
    },
  },
};
</script>

<style scoped>
/* 与 common-tool-page TopPostList 保持一致 */
.top_post_list__item {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 12px;
  border-radius: 8px;
}

.top_post_list__item:active {
  background: #fafafa;
}

.top_post_list__title {
  display: flex;
  align-items: center;
  width: 100%;
  color: #111827;
  font-size: 14px;
  line-height: 18px;
}

.top_post_list__text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.top_post_list__tag {
  display: inline-block;
  flex-shrink: 0;
  margin-right: 4px;
  border-radius: 2px;
  padding: 2px 6px;
  color: #fff;
  background-color: #ff7c46;
  font-size: 10px;
  line-height: 1;
  vertical-align: middle;
}

.top_post_list__toggle {
  margin: 12px;
  padding: 0;
  color: #ff7c46;
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  user-select: none;
}
</style>
